import axios from 'axios'
import local from './local'
import {	Message} from 'element-ui'
// import store from '@/store'
// import {getToken} from '@/utils/auth'
const urlArr = [];

const baseURL = 'https://kmapi.aoxiangae.com/trader'; // 测试

// const baseURL = 'http://121.40.59.64:8081/trader'; // 正式 卡密

//const baseURL = 'http://47.98.50.28:13489/trader'; // 正式 联美



const proName = '商户后台管理系统';
const payNameImg = 'default';



const service = axios.create({
	baseURL: baseURL, // url = base url + request url
	timeout: 30000, // request timeout
	withCredentials: true
})

// request interceptor
service.interceptors.request.use(
	config => {
		const isFormDataRequest = config.isFormData || (config.data instanceof FormData)
		const headers = config.headers || {}
		headers['Content-Type'] = isFormDataRequest ? 'multipart/form-data' : (headers['Content-Type'] || 'application/json')//  注意：设置很关键 
		config.headers = headers
		// **确保请求携带 Cookie**
		// config.withCredentials = true;
		let data = {
			username: local.get('username'),
			tid: local.get('tid')
		}
		let fullUrl = config.baseURL + config.url
		const appendAuthPayload = (payload)=>{
			const authData = data
			if(payload instanceof FormData){
				Object.keys(authData).forEach(key=>{
					if(authData[key] !== undefined){
						payload.append(key,authData[key])
					}
				})
				return payload
			}
			return Object.assign(payload || {}, authData)
		}
		
		if (config.allowRepetition) { //允许重复请求数据的接口
			if (config.url != '/login/dologin' && config.url != '/login/Logout' &&  config.url !='/login/recoverPwd') {

				if (data.tid && data.username) {
					config.data = appendAuthPayload(config.data);
				}else{
					// console.log('=1')
					window.location.href = '/'
					return Promise.reject({
						message: '账号未登录，请重新登录'
					})
				}
			}

			return config

		} else if (urlArr.indexOf(fullUrl) === -1) { //不允许重复请求数据的接口

			urlArr.push(fullUrl);
			setTimeout(() => {
				urlArr.splice(urlArr.indexOf(fullUrl), 1)
			}, 1000)

			if (config.url != '/login/dologin'&& config.url != '/login/Logout' &&  config.url !='/login/recoverPwd') {
				if (data.tid && data.username) {
					config.data = appendAuthPayload(config.data);
				}else{
					// console.log('=2')
					window.location.href = '/'
					return Promise.reject({
						message: '账号未登录，请重新登录'
					})
				}
			}
			return config
		} else {
			return Promise.reject({
				message: '重复请求'
			})
			// return
		}
	},
	error => {
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		// return res
		// 错误码配置
		
		let fullUrl = response.request.responseURL
		urlArr.splice(urlArr.indexOf(fullUrl), 1)
		if (res.status != 1&&res.status != 3&&res.status != 0 &&res.status != 4) {
			//验证码错误  重新获取验证码
			Message({
				message: res.msg || 'Error',
				type: 'error',
				duration: 5 * 1000
			})
			if (res.status === 2) {
				// store.dispatch('user/resetToken')	
				local.remove('tid')
				local.remove('username')
				window.location.href = '/'
				return
			}
			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)
export {
	baseURL,
	proName,
	payNameImg
}
export default service
